import useLicenseCheck from "license/useLicenseCheck";
import usePermissions from "hooks/usePermissions";
const useActionCondition = () => {
  const { security } = useLicenseCheck();
  const { isPermitted } = usePermissions();
  return (security == null ? void 0 : security.isValid) && isPermitted("investigations:edit");
};
export default useActionCondition;
